import { Link } from "gatsby";
import React, { Component } from "react";
import LogoBlack from "../../images/logo.png";
import LogoIFRC from "../../images/logo_ifrc.png";
import LogoMRCS from "../../images/logo_mrcs.png";
import LogoTAF from "../../images/logo_taf.png";

const navigation = {
  social: [
    {
      name: "Email",
      content: "info@mysukarela.com",
    },
    // {
    //   name: "Whatsapp",
    //   content: "017-3039042 (Message Only)",
    // },
  ],
};

export default class Footer extends Component {
  renderLink = (nav: string, title: string) => {
    return (
      <Link to={nav}>
        <p className="cursor-pointer font-bold text-base underline text-gray-500 hover:text-red-600">
          {title}
        </p>
      </Link>
    );
  };

  render() {
    return (
      <footer
        className="w-full bg-white border-t"
        aria-labelledby="footerHeading"
      >
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-8 xl:col-span-2">
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold tracking-wider uppercase">
                  Company
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>{this.renderLink("/aboutUs", "About Us")}</li>
                  <li>{this.renderLink("/faqs", "FAQs")}</li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold tracking-wider uppercase">
                  NGO
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>{this.renderLink("/forNGO", "For NGO")}</li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold tracking-wider uppercase">
                  Legal
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>{this.renderLink("/terms", "Terms & Conditions")}</li>
                  <li>{this.renderLink("/privacy", "Privacy Policy")}</li>
                </ul>
              </div>
            </div>
            <div className="mt-12 space-y-4 xl:col-span-1 xl:mt-0">
              <img className="h-6 lg:h-7" src={LogoBlack} alt="MySukarela" />
              <p className="text-gray-500 font-body text-base">Powered By :</p>
              <div className="flex flex-row">
                <img
                  className="h-12 lg:h-14"
                  src={LogoIFRC}
                  alt="International Federation Red Cross"
                />
                <img
                  className="ml-4 h-12 lg:h-16"
                  src={LogoMRCS}
                  alt="Malaysia Red Crescent Society"
                />
                <img
                  className="ml-2 h-14 lg:h-20"
                  src={LogoTAF}
                  alt="The Asia Foundation"
                />
              </div>
              <p className="text-gray-500 font-body text-base">
                Volunteering As A New Norm
              </p>
              {navigation.social.map((item) => (
                <p className="text-gray-500">
                  {item.name} : {item.content}
                </p>
              ))}
            </div>
          </div>

          <div className="mt-12 border-t border-gray-200 pt-8">
            <p className="text-base text-gray-400 xl:text-center">
              © 2021 Malaysia Red Crescent Society. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }
}
